import { useMutation, useQueryClient } from "@tanstack/react-query"
import { useTranslation } from "react-i18next"
import { toast } from "sonner"

import { api } from "@/lib/api-client"
import { queryKeys } from "@/lib/query-keys"

function deleteTemplate(data: { templateId: string; type: "personal" | "company" }): Promise<void> {
  return api.delete(`/parser/delete-template?template_id=${data.templateId}&type=${data.type}`)
}

export function useDeleteTemplateMutation() {
  const { t } = useTranslation()
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: deleteTemplate,
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: queryKeys.parserTemplates(),
      })

      toast.success(t("pages.ai_parser.toasts.template_deleted_success"))
    },
    onError: () => {
      toast.error(t("pages.ai_parser.toasts.template_delete_failed"))
    },
  })
}
